import { StoreState } from '../store-interfaces';
import { selectActiveAdAccount } from './adAccountsSelecotrs';

export const selectFacebookAdAudiences = (state: StoreState) =>
  (state.adAudiences.entities || []).filter(
    aud => aud?.subtype.toLowerCase() === 'custom',
  );

export const selectFacebookAdAudiencesByAdAccount = (
  state: StoreState,
  adAccountRemoteId?: string,
) => {
  const activeAccountRemoteId = adAccountRemoteId;
  const audiences = selectFacebookAdAudiences(state);

  return !activeAccountRemoteId || activeAccountRemoteId === 'all'
    ? audiences
    : audiences.filter(a => a.adAccount?.remoteId === activeAccountRemoteId);
};

export const selectAdAudience = (state: StoreState, id) =>
  state.adAudiences.entities.find(v => v.id === id);
